import * as Sentry from '@sentry/react'
import { isRunningLocally } from 'src/helpers'
import { env } from 'src/helpers/runtime'

const environment =
  env('cognito_client') === '1v2m1ihhl2a3dbdhpue48c66uj' ? 'dev' : 'prod'

// Only initialize Sentry in production (not in local environments)
if (!isRunningLocally()) {
  Sentry.init({
    dsn: 'https://5a1ccfeb72f0937af850e4712d4879f4@o4505150152048640.ingest.us.sentry.io/4510545139335168',
    environment,
    sendDefaultPii: true,
    enableLogs: true,

    // Tracing
    integrations: [Sentry.browserTracingIntegration()],

    // Capture 100% of transactions in dev, 10% in production
    // Adjust as needed based on your traffic volume
    tracesSampleRate: environment === 'dev' ? 1.0 : 0.05,

    // Enable distributed tracing for your API endpoints
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/buzz-test-api\.payready\.com/,
      /^https:\/\/buzz-api\.payready\.com/,
    ],
  })
}
